import PropTypes from 'prop-types';

const BillableDepartmentHourRatios = {
  totalBillableRatio: PropTypes.number,
  totalNonBillableRatio: PropTypes.number,
  totalAbsenteeRatio: PropTypes.number,
};

export default BillableDepartmentHourRatios;
